<template>
  <el-aside width="200px">
    <div class="aside-page scroll-bar">

      <!-- 导航搜索框 -->
      <div class="menu-search">
        <el-input v-model="searchQuery" placeholder="搜索菜单" clearable />
      </div>

      <el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" router>
        <div v-for="(item, ind) in filteredMenu" :key="ind" :index="item.id + ''">
          <el-menu-item v-if="item.children.length == 0" :index="item.url"
                        :route="{ path: item.url }">
            {{ item.entityName }}
          </el-menu-item>
          <el-submenu v-else :index="item.id + ''">
            <template slot="title">
              <span>{{ item.entityName }}</span>
            </template>
            <template v-for="(k, i) in item.children">
              <template v-if="k.children.length == 0">
                <el-menu-item :key="i" :index="k.url" :route="{ path: k.url }" @click="toolClearType">
                  {{ k.entityName }}
                </el-menu-item>
              </template>
              <template v-else>
                <el-submenu v-if="k.children[0].level == 1" :key="i" :index="k.id + ''">
                  <template slot="title">{{ k.entityName }}</template>
                  <el-menu-item v-for="(s, t) in k.children" :key="t" :index="s.url"
                                :route="{ path: s.url }" @click="toolClearType">
                    {{ s.entityName }}
                  </el-menu-item>
                </el-submenu>
                <template v-else>
                  <el-menu-item :key="i" :index="k.url" :route="{ path: k.url }" @click="toolClearType">
                    {{ k.entityName }}
                  </el-menu-item>
                </template>
              </template>
            </template>
          </el-submenu>
        </div>
      </el-menu>
    </div>
  </el-aside>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: '', // 搜索关键词
      option: [],
    };
  },
  computed: {
    /**
     * 根据搜索关键词过滤菜单项
     */
    filteredMenu() {
      if (!this.searchQuery) {
        return this.option; // 如果没有搜索内容，返回原始菜单
      }
      const query = this.searchQuery.toLowerCase();
      return this.option
        .map(item => {
          if (item.entityName.toLowerCase().includes(query)) {
            return item; // 如果父级菜单匹配，直接返回整个菜单项
          }
          if (item.children && item.children.length > 0) {
            const filteredChildren = item.children.filter(child =>
              child.entityName.toLowerCase().includes(query)
            );
            if (filteredChildren.length > 0) {
              return { ...item, children: filteredChildren }; // 如果子菜单匹配，返回父级并更新子菜单
            }
          }
          return null; // 不匹配的菜单项返回 null
        })
        .filter(item => item !== null); // 过滤掉不匹配的 null 项
    }
  },
  created() {
    this.findSidebarList();
  },
  methods: {
    async findSidebarList() {
      let details = await this.service.User.SidebarList({ type: 1 });
      let btnData = await this.service.User.getButton({ type: 1 });
      if (details.code == 0) {
        this.option = details.data.children;
        sessionStorage.setItem('optionBtn', JSON.stringify(this.option));
      }
      if (btnData.code == 0) {
        sessionStorage.setItem('btn_list', btnData.data.buttons)
      } else {
        tipsTemplate(btnData.msg, "error", "1");
      }
    },
    toolClearType() {
      sessionStorage.setItem('contType', '');
      // this.requestMerchData(); // 获取商户数据
      // this.requestServiceList(); // 获取服务商列表
      // this.requestAgentInfo(); // 获取代理商列表
    },
    /*
    * Function: requestMerchData()
    * Desc: 获取商户数据
    * Date: 2022-01-11
    * Author: jxx
    * */
    async requestMerchData() {
      // 获取商户接口
      let details = await this.service.sellerinfo.AgentSelectList({ type: 1 });
      if (details.code == 0) {
        // 商户列表
        sessionStorage.setItem("merchList", JSON.stringify(details.data))
      } else {
        // 获取商户接口失败提示
        tipsTemplate(details.msg, "", "2", "确定");
      }
    },
    /*
    * Function: requestServiceList()
    * Desc: 获取服务商列表
    * Date: 2023-12-26
    * Author: jxx
    * */
    async requestServiceList() {
      // 获取服务商接口
      let details = await this.service.sellerinfo.AgentSelectList({ type: 2 });
      if (details.code == 0) {
        // 服务商列表
        sessionStorage.setItem("serviList", JSON.stringify(details.data));
      } else {
        // 接口调用失败提示
        tipsTemplate(details.msg, "", "2", "确定");
      }
    },
    /*
    * Function: requestAgentInfo()
    * Desc: 获取代理商信息
    * Date: 2022-01-11
    * Author: jxx
    * */
    async requestAgentInfo() {
      // 获取代理商信息接口
      let details = await this.service.sellerinfo.AgentSelectList({ type: 3 });
      if (details.code == 0) {
        // 代理商列表
        sessionStorage.setItem("agentList", JSON.stringify(details.data));
      } else {
        // 接口调用失败提示
        tipsTemplate(details.msg, "", "2", "确定");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-aside {
  width: 230px !important;
  overflow-x: hidden;
  position: relative;
  z-index: 2000;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .aside-page {
    width: 100%;
    height: 100%;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comAside.vue